import { Route, Switch } from 'react-router-dom'

import { usePathnameTracking } from 'Packages/track'

import Flashcards from './flashcards/Index'
import Videos from './videos/Index'
import FlashcardsSearchConfig from './flashcards/components/FlashcardsSearchConfig'
import VideosSearchConfig from './videos/components/VideosSearchConfig'

import { routes } from './constants'

export default function Routes() {
  usePathnameTracking()

  return (
    <Switch>
      <Route path={routes.flashcards}>
        <FlashcardsSearchConfig>
          <Flashcards />
        </FlashcardsSearchConfig>
      </Route>
      <Route path={routes.videos}>
        <VideosSearchConfig>
          <Videos />
        </VideosSearchConfig>
      </Route>
    </Switch>
  )
}
